import request from '@/utils/request'

const orderGoods = {
  name: 'orderGoods',
  state: {
    isOrderGoodsDetailLoading: false,
    orderGoodsDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_ORDERGOODS_DETAIL_LOADING: (state, data) => {
      state.isOrderGoodsDetailLoading = data
    },
    SET_MODULES_ORDERGOODS_DETAIL_DATA: (state, data) => {
      state.orderGoodsDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryOrderGoodsDetailData({ commit }, id) {
      commit('SET_IS_MODULES_ORDERGOODS_DETAIL_LOADING', true)
      commit('SET_MODULES_ORDERGOODS_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/orderGoods/orderGoodsDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_ORDERGOODS_DETAIL_LOADING', false)
          commit('SET_MODULES_ORDERGOODS_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_ORDERGOODS_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetOrderGoodsDetailData({ commit }) {
      commit('SET_MODULES_ORDERGOODS_DETAIL_DATA', {})
    }
  }
}

export default orderGoods
